import { Vue } from 'ui.vue';
import DeliveryPriceComponent from "./delivery-price-component.vue";

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.delivery-price').forEach((element) => {
		Vue.create({
			el: element,
			template: `
				<delivery-price-component
				    :productId="productId"
					default-city="${currentCity}"
				/>
			`,
			data: () => {
				return {
					...{
						productId: undefined,
					},
					...window[element.dataset.dataId],
				}
			},
			components: {
				'delivery-price-component': DeliveryPriceComponent,
			}
		});
	});
});
